/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface WebhooksService {
  /** @summary Handle Stripe Webhook */
  handleStripeWebhookWebhooksStripePost: {
    /** @summary Handle Stripe Webhook */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleStripeWebhookWebhooksStripePostBody,
        HandleStripeWebhookWebhooksStripePostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleStripeWebhookWebhooksStripePostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleStripeWebhookWebhooksStripePostBody,
          HandleStripeWebhookWebhooksStripePostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<HandleStripeWebhookWebhooksStripePostData, HandleStripeWebhookWebhooksStripePostError>
      >
    ): Promise<
      RequestFnResponse<HandleStripeWebhookWebhooksStripePostData, HandleStripeWebhookWebhooksStripePostError>
    >;
    /** @summary Handle Stripe Webhook */
    getMutationKey(
      parameters: DeepReadonly<HandleStripeWebhookWebhooksStripePostParameters> | void
    ): ServiceOperationMutationKey<
      HandleStripeWebhookWebhooksStripePostSchema,
      HandleStripeWebhookWebhooksStripePostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Stripe Webhook
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleStripeWebhookWebhooksStripePostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleStripeWebhookWebhooksStripePostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleStripeWebhookWebhooksStripePostSchema,
        HandleStripeWebhookWebhooksStripePostData,
        HandleStripeWebhookWebhooksStripePostParameters,
        TVariables,
        OperationError<HandleStripeWebhookWebhooksStripePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleStripeWebhookWebhooksStripePostData,
      OperationError<HandleStripeWebhookWebhooksStripePostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Stripe Webhook
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleStripeWebhookWebhooksStripePostBody,
        HandleStripeWebhookWebhooksStripePostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleStripeWebhookWebhooksStripePostSchema,
        HandleStripeWebhookWebhooksStripePostData,
        HandleStripeWebhookWebhooksStripePostParameters,
        TVariables,
        OperationError<HandleStripeWebhookWebhooksStripePostError>,
        TContext
      >
    ): UseMutationResult<
      HandleStripeWebhookWebhooksStripePostData,
      OperationError<HandleStripeWebhookWebhooksStripePostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Stripe Webhook
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleStripeWebhookWebhooksStripePostTotal = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleStripeWebhookWebhooksStripePostTotal = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleStripeWebhookWebhooksStripePostSchema,
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Stripe Webhook
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleStripeWebhookWebhooksStripePostPendingMutationVariables = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleStripeWebhookWebhooksStripePostMutationData = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleStripeWebhookWebhooksStripePostData,
        OperationError<HandleStripeWebhookWebhooksStripePostError>,
        MutationVariables<HandleStripeWebhookWebhooksStripePostBody, HandleStripeWebhookWebhooksStripePostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleStripeWebhookWebhooksStripePostSchema,
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleStripeWebhookWebhooksStripePostData,
          OperationError<HandleStripeWebhookWebhooksStripePostError>,
          MutationVariables<HandleStripeWebhookWebhooksStripePostBody, HandleStripeWebhookWebhooksStripePostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Handle Stripe Webhook */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleStripeWebhookWebhooksStripePostSchema,
            HandleStripeWebhookWebhooksStripePostBody,
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostParameters,
            OperationError<HandleStripeWebhookWebhooksStripePostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Stripe Webhook
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.webhooksService.handleStripeWebhookWebhooksStripePost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleStripeWebhookWebhooksStripePostBody,
              HandleStripeWebhookWebhooksStripePostData,
              HandleStripeWebhookWebhooksStripePostParameters,
              OperationError<HandleStripeWebhookWebhooksStripePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleStripeWebhookWebhooksStripePostSchema,
              HandleStripeWebhookWebhooksStripePostBody,
              HandleStripeWebhookWebhooksStripePostData,
              HandleStripeWebhookWebhooksStripePostParameters,
              OperationError<HandleStripeWebhookWebhooksStripePostError>,
              TContext
            >
      ):
        | Mutation<
            HandleStripeWebhookWebhooksStripePostData,
            HandleStripeWebhookWebhooksStripePostError,
            MutationVariables<
              HandleStripeWebhookWebhooksStripePostBody,
              HandleStripeWebhookWebhooksStripePostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleStripeWebhookWebhooksStripePostBody,
              HandleStripeWebhookWebhooksStripePostData,
              HandleStripeWebhookWebhooksStripePostParameters,
              OperationError<HandleStripeWebhookWebhooksStripePostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleStripeWebhookWebhooksStripePostSchema,
              HandleStripeWebhookWebhooksStripePostBody,
              HandleStripeWebhookWebhooksStripePostData,
              HandleStripeWebhookWebhooksStripePostParameters,
              OperationError<HandleStripeWebhookWebhooksStripePostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleStripeWebhookWebhooksStripePostData,
          HandleStripeWebhookWebhooksStripePostError,
          MutationVariables<HandleStripeWebhookWebhooksStripePostBody, HandleStripeWebhookWebhooksStripePostParameters>,
          TContext
        >
      >;
    };
    schema: HandleStripeWebhookWebhooksStripePostSchema;
    types: {
      parameters: HandleStripeWebhookWebhooksStripePostParameters;
      data: HandleStripeWebhookWebhooksStripePostData;
      error: HandleStripeWebhookWebhooksStripePostError;
      body: HandleStripeWebhookWebhooksStripePostBody;
    };
  };
  /**
   * @summary Handle Lob Webhook
   * @description See: https://docs.lob.com/guides/webhooks
   */
  handleLobWebhookWebhooksLobPost: {
    /**
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleLobWebhookWebhooksLobPostBody,
        HandleLobWebhookWebhooksLobPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleLobWebhookWebhooksLobPostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleLobWebhookWebhooksLobPostBody,
          HandleLobWebhookWebhooksLobPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<HandleLobWebhookWebhooksLobPostData, HandleLobWebhookWebhooksLobPostError>>
    ): Promise<RequestFnResponse<HandleLobWebhookWebhooksLobPostData, HandleLobWebhookWebhooksLobPostError>>;
    /**
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     */
    getMutationKey(
      parameters: DeepReadonly<HandleLobWebhookWebhooksLobPostParameters> | void
    ): ServiceOperationMutationKey<HandleLobWebhookWebhooksLobPostSchema, HandleLobWebhookWebhooksLobPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleLobWebhookWebhooksLobPostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleLobWebhookWebhooksLobPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleLobWebhookWebhooksLobPostSchema,
        HandleLobWebhookWebhooksLobPostData,
        HandleLobWebhookWebhooksLobPostParameters,
        TVariables,
        OperationError<HandleLobWebhookWebhooksLobPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleLobWebhookWebhooksLobPostData,
      OperationError<HandleLobWebhookWebhooksLobPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleLobWebhookWebhooksLobPostBody,
        HandleLobWebhookWebhooksLobPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleLobWebhookWebhooksLobPostSchema,
        HandleLobWebhookWebhooksLobPostData,
        HandleLobWebhookWebhooksLobPostParameters,
        TVariables,
        OperationError<HandleLobWebhookWebhooksLobPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleLobWebhookWebhooksLobPostData,
      OperationError<HandleLobWebhookWebhooksLobPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleLobWebhookWebhooksLobPostTotal = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleLobWebhookWebhooksLobPostTotal = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleLobWebhookWebhooksLobPostSchema,
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleLobWebhookWebhooksLobPostPendingMutationVariables = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleLobWebhookWebhooksLobPostMutationData = qraft.webhooksService.handleLobWebhookWebhooksLobPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleLobWebhookWebhooksLobPostData,
        OperationError<HandleLobWebhookWebhooksLobPostError>,
        MutationVariables<HandleLobWebhookWebhooksLobPostBody, HandleLobWebhookWebhooksLobPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleLobWebhookWebhooksLobPostSchema,
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleLobWebhookWebhooksLobPostData,
          OperationError<HandleLobWebhookWebhooksLobPostError>,
          MutationVariables<HandleLobWebhookWebhooksLobPostBody, HandleLobWebhookWebhooksLobPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleLobWebhookWebhooksLobPostSchema,
            HandleLobWebhookWebhooksLobPostBody,
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostParameters,
            OperationError<HandleLobWebhookWebhooksLobPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Lob Webhook
     * @description See: https://docs.lob.com/guides/webhooks
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.webhooksService.handleLobWebhookWebhooksLobPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.webhooksService.handleLobWebhookWebhooksLobPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleLobWebhookWebhooksLobPostBody,
              HandleLobWebhookWebhooksLobPostData,
              HandleLobWebhookWebhooksLobPostParameters,
              OperationError<HandleLobWebhookWebhooksLobPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleLobWebhookWebhooksLobPostSchema,
              HandleLobWebhookWebhooksLobPostBody,
              HandleLobWebhookWebhooksLobPostData,
              HandleLobWebhookWebhooksLobPostParameters,
              OperationError<HandleLobWebhookWebhooksLobPostError>,
              TContext
            >
      ):
        | Mutation<
            HandleLobWebhookWebhooksLobPostData,
            HandleLobWebhookWebhooksLobPostError,
            MutationVariables<HandleLobWebhookWebhooksLobPostBody, HandleLobWebhookWebhooksLobPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleLobWebhookWebhooksLobPostBody,
              HandleLobWebhookWebhooksLobPostData,
              HandleLobWebhookWebhooksLobPostParameters,
              OperationError<HandleLobWebhookWebhooksLobPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleLobWebhookWebhooksLobPostSchema,
              HandleLobWebhookWebhooksLobPostBody,
              HandleLobWebhookWebhooksLobPostData,
              HandleLobWebhookWebhooksLobPostParameters,
              OperationError<HandleLobWebhookWebhooksLobPostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleLobWebhookWebhooksLobPostData,
          HandleLobWebhookWebhooksLobPostError,
          MutationVariables<HandleLobWebhookWebhooksLobPostBody, HandleLobWebhookWebhooksLobPostParameters>,
          TContext
        >
      >;
    };
    schema: HandleLobWebhookWebhooksLobPostSchema;
    types: {
      parameters: HandleLobWebhookWebhooksLobPostParameters;
      data: HandleLobWebhookWebhooksLobPostData;
      error: HandleLobWebhookWebhooksLobPostError;
      body: HandleLobWebhookWebhooksLobPostBody;
    };
  };
  /**
   * @summary Handle Twilio Debugger Webhook
   * @description Receive Twilio Debugger alerts and forward errors to Sentry.
   */
  handleTwilioDebuggerWebhookWebhooksTwilioPost: {
    /**
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
        options: ServiceOperationMutationFnOptions<
          HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
          HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
          HandleTwilioDebuggerWebhookWebhooksTwilioPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostError
      >
    >;
    /**
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     */
    getMutationKey(
      parameters: DeepReadonly<HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters> | void
    ): ServiceOperationMutationKey<
      HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
      HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends HandleTwilioDebuggerWebhookWebhooksTwilioPostBody, TContext = unknown>(
      parameters: DeepReadonly<HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
        TVariables,
        OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
      OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
        HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
        TVariables,
        OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
        TContext
      >
    ): UseMutationResult<
      HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
      OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const handleTwilioDebuggerWebhookWebhooksTwilioPostTotal = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const handleTwilioDebuggerWebhookWebhooksTwilioPostTotal = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const handleTwilioDebuggerWebhookWebhooksTwilioPostPendingMutationVariables = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const handleTwilioDebuggerWebhookWebhooksTwilioPostMutationData = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
        OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
        MutationVariables<
          HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
          HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
          OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
          MutationVariables<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
            OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Handle Twilio Debugger Webhook
     * @description Receive Twilio Debugger alerts and forward errors to Sentry.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.webhooksService.handleTwilioDebuggerWebhookWebhooksTwilioPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
              OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
              OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
              TContext
            >
      ):
        | Mutation<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostError,
            MutationVariables<
              HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
              OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
              HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters,
              OperationError<HandleTwilioDebuggerWebhookWebhooksTwilioPostError>,
              TContext
            >
      ): Array<
        Mutation<
          HandleTwilioDebuggerWebhookWebhooksTwilioPostData,
          HandleTwilioDebuggerWebhookWebhooksTwilioPostError,
          MutationVariables<
            HandleTwilioDebuggerWebhookWebhooksTwilioPostBody,
            HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters
          >,
          TContext
        >
      >;
    };
    schema: HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema;
    types: {
      parameters: HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters;
      data: HandleTwilioDebuggerWebhookWebhooksTwilioPostData;
      error: HandleTwilioDebuggerWebhookWebhooksTwilioPostError;
      body: HandleTwilioDebuggerWebhookWebhooksTwilioPostBody;
    };
  };
}
/** @summary Handle Stripe Webhook */
export const handleStripeWebhookWebhooksStripePost = {
  schema: {
    method: 'post',
    url: '/webhooks/stripe',
  },
} as {
  schema: HandleStripeWebhookWebhooksStripePostSchema;
  [QraftServiceOperationsToken]: WebhooksService['handleStripeWebhookWebhooksStripePost'];
};
/**
 * @summary Handle Lob Webhook
 * @description See: https://docs.lob.com/guides/webhooks
 */
export const handleLobWebhookWebhooksLobPost = {
  schema: {
    method: 'post',
    url: '/webhooks/lob',
  },
} as {
  schema: HandleLobWebhookWebhooksLobPostSchema;
  [QraftServiceOperationsToken]: WebhooksService['handleLobWebhookWebhooksLobPost'];
};
/**
 * @summary Handle Twilio Debugger Webhook
 * @description Receive Twilio Debugger alerts and forward errors to Sentry.
 */
export const handleTwilioDebuggerWebhookWebhooksTwilioPost = {
  schema: {
    method: 'post',
    url: '/webhooks/twilio',
  },
} as {
  schema: HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema;
  [QraftServiceOperationsToken]: WebhooksService['handleTwilioDebuggerWebhookWebhooksTwilioPost'];
};
export const webhooksService = {
  handleStripeWebhookWebhooksStripePost,
  handleLobWebhookWebhooksLobPost,
  handleTwilioDebuggerWebhookWebhooksTwilioPost,
} as const;
type HandleStripeWebhookWebhooksStripePostSchema = {
  method: 'post';
  url: '/webhooks/stripe';
};
type HandleStripeWebhookWebhooksStripePostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleStripeWebhookWebhooksStripePostData =
  paths['/webhooks/stripe']['post']['responses']['200']['content']['application/json'];
type HandleStripeWebhookWebhooksStripePostError = unknown;
type HandleStripeWebhookWebhooksStripePostBody = undefined;
type HandleLobWebhookWebhooksLobPostSchema = {
  method: 'post';
  url: '/webhooks/lob';
};
type HandleLobWebhookWebhooksLobPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleLobWebhookWebhooksLobPostData =
  paths['/webhooks/lob']['post']['responses']['200']['content']['application/json'];
type HandleLobWebhookWebhooksLobPostError = unknown;
type HandleLobWebhookWebhooksLobPostBody = undefined;
type HandleTwilioDebuggerWebhookWebhooksTwilioPostSchema = {
  method: 'post';
  url: '/webhooks/twilio';
};
type HandleTwilioDebuggerWebhookWebhooksTwilioPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type HandleTwilioDebuggerWebhookWebhooksTwilioPostData =
  paths['/webhooks/twilio']['post']['responses']['200']['content']['application/json'];
type HandleTwilioDebuggerWebhookWebhooksTwilioPostError = unknown;
type HandleTwilioDebuggerWebhookWebhooksTwilioPostBody = undefined;
